export default {
    methods:{
        /**
         * Valida los datos de un formulario de acuerdo a los datos establecidos
         * @param {*} payload Datos para validar
         * @param {*} validaciones Listado que contiene las validaciones
         * @return  {boolean} true si todo está validado correctamente, y false si no cumple con las validaciones
         * @author Alejandro Trujillo Delgado
         */
        validateForm(payload, validaciones){
            if(!payload){
                return false
            }
            if( !validaciones || validaciones.length <= 0 ){
                return true
            }

            let invalid = 0
            Object.entries(payload).forEach(([key,value])=> {
                if(this.individualValidateForm(key,value,validaciones) != true){
                    invalid++
                }
            })
            return invalid > 0 ? false : true
        },
        /**
         * Valida los datos de un elemento en especifico
         * @param {*} key Parametro a validar
         * @param {*} value Valor del parametro
         * @param {*} validaciones Listado que contiene las validaciones
         * @return  {*} true si todo está validado correctamente, y si es diferente a true, devuelve mensaje de la validacion incorrecta
         * @author Alejandro Trujillo Delgado
         */
        individualValidateForm(key,value,validaciones){
            let validationIndex = validaciones.findIndex(x=>x.input==key)
            
            if(!this.validaciones[validationIndex]){
                return true
            }

            let result = true
            let number_result = 0

            this.validaciones[validationIndex].validaciones.forEach((validacion)=>{  
                result = validacion(value)
                if(result != true && number_result<=0){
                    validaciones[validationIndex].msg = result
                    validaciones[validationIndex].error = true
                    number_result++
                    return
                }else if(number_result == 0){
                    validaciones[validationIndex].msg = ''
                    validaciones[validationIndex].error = false
                }
            })

            return result
        },
        /**
         * Obtiene el objeto en especifico de a cuerdo al input y el valor del error(true)
         * @param {*} desc_input Valor del input
         * @param {*} validaciones Listado que contiene las validaciones
         * @return  {*} Objecto de la validacion
         * @author Alejandro Trujillo Delgado
         */
        getValidationForm(desc_input,validaciones){
            return validaciones.find(x => x.input == desc_input && x.error == true)
        },
                /**
         * Obtiene el objeto en especifico de a cuerdo al input y el valor del error(true)
         * @param {*} desc_input Valor del input
         * @param {*} validaciones Listado que contiene las validaciones
         * @return  {*} Objecto de la validacion
         * @author Alejandro Trujillo Delgado
         */
        resetValidationForm(validaciones){
            return validaciones.forEach((x)=>{x.error = false; x.msg = ''})
        }
    }
}